<template>
  <div>
    <v-data-table
      :options.sync="options"
      :server-items-length="totalItems"
      :loading="loading"
      :headers="headers"
      :items="items"
      :search="search_form"
      :footer-props="{
        'items-per-page-options': [10, 20, 30, 40, 50, 100]
      }"
      :items-per-page="20"
      class="elevation-1"
    >
      <!-- <template v-slot:item.action="{ item }">
        <v-icon small class="mr-3" @click="editItem(item)">mdi-pencil</v-icon>
        <v-icon small class="mr-3" @click="historyItem(item)">mdi-account-badge-outline</v-icon>
        <v-icon small color="red" @click="deleteItem(item)">mdi-delete</v-icon>
      </template>-->
      <template v-slot:top>
        <!-- <v-subheader>Zoznam Odsúdených</v-subheader>
        <v-divider></v-divider> -->
        <v-text-field
          v-model="search_form"
          class="pa-3"
          label="Vyhľadať"
        />
      </template>
    </v-data-table>

    <v-btn
      fab
      bottom
      left
      color="pink"
      dark
      fixed
      @click="create"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <v-card>
        <v-card-title v-if="update">
          Zmena odsúdeného
        </v-card-title>
        <v-card-title v-else>
          Nový odsúdený
        </v-card-title>

        <v-container grid-list-sm>
          <v-layout wrap>
            <v-flex xs12>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.base_number"
                    label="Základné číslo"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-text-field
                    v-model="new_item.birth_date"
                    label="Dátum narodenia (v tvare 1990-01-15)"
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="new_item.gender"
                    placeholder="Pohlavie"
                    label="Pohlavie"
                    :items="pohlavia"
                    required
                  />
                </v-col>

                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="new_item.institution"
                    item-text="name"
                    item-value="id"
                    placeholder="Ústav"
                    label="Ústav"
                    :items="institutions"
                    auto-select-first
                    :search-input.sync="search"
                    cache-items
                    :loading="loading_institutions"
                    hide-no-data
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="dialog = false; update = false"
          >
            Zrušiť
          </v-btn>

          <v-btn
            v-if="update"
            text
            @click="updateItem"
          >
            Zmeniť
          </v-btn>
          <v-btn
            v-else
            text
            @click="createItem"
          >
            Vytvoriť
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

export default {
  data: () => ({
    loading: true,
    loading_institutions: false,
    dialog: false,
    update: false,
    search: "",
    search_form: "",
    totalItems: 0,
    options: {},

    pohlavia: ["muž", "žena"],

    headers: [
      { text: "Interné ID", value: "id" },
      { text: "Základné číslo", value: "base_number" },
      { text: "Meno", value: "name_full" },
      { text: "Dátum narodenia", value: "birth_date" },
      { text: "Pohlavie", value: "gender" },
      { text: "Ústav", value: "institution_full.name" },
      { text: "Akcie", value: "action", sortable: false }
    ],
    new_item: {
      base_number: "",
      birth_date: "",
      institution: "",
      gender: ""
    },
    items: [],
    institutions: []
  }),

  watch: {
    search(val) {
      val && this.querySelections(val);
    },
    search_form() {
      this.getDataFromApi();
    },
    options: {
      handler() {
        this.getDataFromApi();
      }
    },
    deep: true
  },

  created() {
    // this.querySelections("");
  },

  methods: {
    historyItem(item) {
      this.$router.push({ name: "prisoners_history", params: { id: item.id } });
    },
    editItem(item) {
      this.new_item = Object.assign({}, item);
      this.dialog = true;
      this.update = true;
    },
    create() {
      this.dialog = true;
      this.update = false;

      this.new_item.base_number = "";
      this.new_item.birth_date = "";
      this.new_item.institution = "";
    },

    getPrisoners(sort, search, limit, offset) {
      this.loading = true;
      apiService.getPrisoners(sort, search, limit, offset).then(response => {
        this.items = response.results;
        this.totalItems = response.count;
        this.loading = false;
      });
    },
    createItem() {
      apiService.createPrisoner(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();

          this.new_item.base_number = "";
          this.new_item.birth_date = "";
          this.new_item.institution = "";

          this.dialog = false;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    updateItem() {
      apiService.updatePrisoner(this.new_item).then(
        () => {
          this.snackbar_success = true;
          this.getDataFromApi();

          this.new_item.base_number = "";
          this.new_item.birth_date = "";
          this.new_item.institution = "";

          this.dialog = false;
          this.update = false;
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },

    querySelections(v) {
      this.loading_institutions = true;

      apiService.searchInstitutions(v).then(response => {
        this.institutions = response.results;
        this.loading_institutions = false;
      });
    },

    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let sort = "";
      if (sortBy) {
        if (sortBy.length === 1 && sortDesc.length === 1) {
          sort = sortBy[0]
            .replace(/\./g, "__")
            .replace("prisoner_full", "prisoner")
            .replace("institution_full", "institution");
          if (!sortDesc[0]) sort = "-" + sort;
        }
      }

      let offset = "";
      if (itemsPerPage > 0) {
        offset = (page - 1) * itemsPerPage;
      }

      this.getPrisoners(sort, this.search_form, itemsPerPage, offset);
    }
  }
};
</script>